module.exports = __webpack_public_path__ + "img/view.7108eeb6.svg";